import React from 'react'
import { Container, Typography, Grid, Link } from '@mui/material'
import Footer from '../components/Footer'

const RestApi: React.FC = () => {
  return (
    <React.Fragment>
      <Container maxWidth='md' sx={{ mt: 30, height: '23vh' }}>
        <Grid container direction='column' justifyContent='center' spacing={2}>
          <Grid item>
            <Typography variant='h4' align='center'>
              Rest API
            </Typography>
          </Grid>
          <Grid item xl={6} mb={4}>
            <Typography variant='body1' color='text.secondary' align='center'>
              Medical Analyses can also provide you with a REST API, so you can integrate drug interaction checks, dosage adjustment information and medical
              calculations directly into your own system. If you are interested, please contact us at{' '}
              <Link href='mailto:contact@medicalanalyses.com'>contact@medicalanalyses.com</Link> and we will get back to you with the details.
            </Typography>
          </Grid>
        </Grid>
      </Container>
      <Footer />
    </React.Fragment>
  )
}

export default RestApi
